import { render, staticRenderFns } from "./UI.vue?vue&type=template&id=40538ad5&scoped=true&"
import script from "./UI.vue?vue&type=script&lang=js&"
export * from "./UI.vue?vue&type=script&lang=js&"
import style0 from "./UI.vue?vue&type=style&index=0&id=40538ad5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40538ad5",
  null
  
)

export default component.exports